<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="form pt-15">
      <div class="text-center">
        <h2 class="font-white">Forgot Password</h2>
      </div>
      <div class="email">
        <label for="emailInput">Email: </label>
        <b-form-input
          id="emailInput"
          v-model="email"
          type="text"
          placeholder="Enter Email"
          required
        ></b-form-input>
      </div>
      <div class="text-center mt-3">
        <button class="btn btn-outline-white" @click="resetPassword">
          Reset Password
        </button>
      </div>
      <div class="text-center mt-7">
        <span
          style="color: #fff; text-decoration: underline; cursor: pointer"
          @click="() => $router.push({ name: 'Login' })"
        >
          Back to Login
        </span>
      </div>
    </div>
    <v-dialog v-model="showResetConfirm" width="500" persistent>
      <div class="content-dialog">
        <div>
          <h3 style="padding: 0rem 0 2rem">
            {{ resetSuccess ? resetSuccess : resetFail }}
          </h3>
          <div class="text-center">
            <button class="btn-back" @click="hideDialog">ปิด</button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import UserService from "@/services/api/user.service";
export default {
  data() {
    return {
      email: null,
      showResetConfirm: false,
      resetSuccess: null,
      resetFail: null,
      isLoading: false,
    };
  },
  methods: {
    async resetPassword() {
      this.isLoading = true;
      try {
        const body = {
          userIdentity: this.email,
        };
        await UserService.resetPasswordUser(body)
          .then((res) => {
            const data = res.data;
            this.isLoading = false;
            this.showResetConfirm = true;
            if (data.status === "success") {
              this.resetSuccess = `รีเซ็ตรหัสผ่านเรียบร้อยลิงค์จะถูกส่งไปที่ ${this.email}`;
            } else {
              this.resetFail = `ไม่สามารถรีเซ็ตรหัสผ่านได้`;
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.showResetConfirm = true;
            this.resetFail = `ไม่สามารถรีเซ็ตรหัสผ่านได้`;
            console.log("Error: ", err);
          });
      } catch (ex) {
        this.isLoading = false;
        this.showResetConfirm = true;
        this.resetFail = `เกิดข้อผิดพลาดบางประการ`;
        console.log("Error: ", ex);
      }
    },
    hideDialog() {
      this.email = null;
      this.resetSuccess = null;
      this.resetFail = null;
      this.isSubmitReset = false;
      this.showResetConfirm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  position: relative;
  top: 100px;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 1rem 0;
  width: 100%;
  max-width: 330px;

  .email {
    margin: 1rem 0;
  }
}
.font-white {
  color: #fff;
}
.btn-outline-white {
  color: #fff;
  border-color: #fff;
}

.btn:hover {
  color: #222;
  background: #fff;
  border-color: #222;
}
</style>
